import { render, staticRenderFns } from "./orderForm.vue?vue&type=template&id=aec8302c&scoped=true"
import script from "./orderForm.vue?vue&type=script&lang=js"
export * from "./orderForm.vue?vue&type=script&lang=js"
import style0 from "./orderForm.vue?vue&type=style&index=0&id=aec8302c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec8302c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec8302c')) {
      api.createRecord('aec8302c', component.options)
    } else {
      api.reload('aec8302c', component.options)
    }
    module.hot.accept("./orderForm.vue?vue&type=template&id=aec8302c&scoped=true", function () {
      api.rerender('aec8302c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/components/orderForm.vue"
export default component.exports